import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';

interface TableHeaderProps {
  sx?: SxProps<Theme>;
  title?: string;
}

export default function TableHeader({ sx, title }: TableHeaderProps) {
  return (
    <Box
      sx={[
        (theme) => ({
          alignItems: 'center',
          bgcolor: 'transparent',
          borderBottom: `solid 1px ${theme.semantic.border}`,
          display: 'flex',
          height: '100%',
          overflow: 'hidden',
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {title && <OverflowAwareText sx={{ fontWeight: 600 }}>{title}</OverflowAwareText>}
    </Box>
  );
}
